import { ApiErrorResponse } from '@/types/response.type'

/**
 * Type predicate to narrow an unknown error to `ApiErrorResponse`
 */
export function isFetchBaseQueryError(
    error: unknown
): error is ApiErrorResponse {
    return typeof error === 'object' && error != null && 'status' in error && typeof (error as any).status === "number"
}

/**
 * Type predicate to narrow an unknown error to an object with a string 'message' property
 */
export function isErrorWithMessage(
    error: unknown
): error is ApiErrorResponse {
    return (
        typeof error === 'object' && error != null && 'message' in error && typeof (error as any).message === 'string'
    )
}